import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'clsx';

const LinkWithPermission = ({ to, authorized, children, className, ...rest }) => {
  if (authorized) {
    return (
      <Link className={cx('cursor-pointer', className)} to={to} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <div className={className} {...rest}>
      {children}
    </div>
  );
};

export default LinkWithPermission;
